import { memo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Animated, { Extrapolate, interpolate, useAnimatedStyle } from 'react-native-reanimated';
import { COLORS } from '../../styles/colors';
import { fontFamilies } from '../../utils/fontLoader';
import Heading from '../ui/Heading';

// Extract animated step into separate component to avoid hook call inside map
const AnimatedStep = memo(({ step, index, progress }) => {
  const animatedStyle = useAnimatedStyle(() => {
    const currentProgress = progress.value;

    const opacity = interpolate(
      currentProgress,
      [index - 0.325, index - 0.125, index + 0.125, index + 0.325],
      [0, 1, 1, 0],
      Extrapolate.CLAMP
    );

    const translateY = interpolate(
      currentProgress,
      [index - 0.4, index, index + 0.4],
      [30, 0, -30],
      Extrapolate.CLAMP
    );

    return {
      opacity,
      transform: [{ translateY }],
    };
  });

  return (
    <Animated.View style={[styles.textContainer, animatedStyle]}>
      <Heading level="h3" style={styles.title}>
        {step.title}
      </Heading>
      <Text style={styles.description}>{step.description}</Text>
    </Animated.View>
  );
});

AnimatedStep.displayName = 'AnimatedStep';

const AnimatedText = ({ progress, steps }) => {
  return (
    <View style={styles.container}>
      {steps.map((step, index) => (
        <AnimatedStep key={`step-${index}`} step={step} index={index} progress={progress} />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 562, // Match the card height for proper alignment
    justifyContent: 'center',
  },
  textContainer: {
    position: 'absolute',
    width: '100%',
  },
  title: {
    color: COLORS.white,
    marginBottom: 10,
  },
  description: {
    color: 'rgba(255, 255, 255, 0.8)',
    fontFamily: fontFamilies.satoshi.regular,
    fontSize: 16,
    lineHeight: 16 * 1.6,
  },
});

export default AnimatedText;
